module.exports = __webpack_public_path__ + "img/guardians-of-the-multiverse.6fea1268.svg";